import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";

var RosterActions = require("lib/actions/RosterActions");
var ActionUtility = require("lib/shared/ActionUtility");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var AccountPlans = require("lib/account/AccountPlans");
var Spinner = require("components/utility/Spinner");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var DateSpans = require("lib/data/DateSpans");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("appdev/crm/upgrade_token_page.scss");

@connect(
	(state, props) => {
		return {
			discountTokens: RosterSelectors.discountTokens({ state })
		}
	},
	(dispatch, props) => ({
		fetchDiscountTokens: () => {
			return dispatch(RosterActions.fetchDiscountTokens({ embeds: ["upgrade_token.user"] }))
		},
		createDiscountTokens: (discountTokens) => {
			return dispatch(RosterActions.createDiscountTokens({ discountTokens }))
		},
		updateDiscountToken: (tokenID, update) => {
			return dispatch(RosterActions.updateDiscountToken({ id: tokenID, update: update }))
		},
		deleteToken: (id) => {
			dispatch(RosterActions.deleteDiscountToken({ id }))
			return dispatch(RosterActions.fetchDiscountTokens({ embeds: ["upgrade_token.user"] }))
		},
		clearDiscountTokens: () => {
			return dispatch(RosterActions.clearDiscountTokens({}));
		}
	})
)
class DiscountTokenPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = _.extend({}, this.getInitialFormState(), { editingFields: {}, editedInformation: {} } )
	}

	fetchPlanType(plan) {
		if (plan.includes("gold")) {
			return "gold";
		} else if (plan.includes("silver")) {
			return "silver";
		}
	}
	fetchPeriod(plan) {
		if (plan.includes("semester")) {
			return "semester";
		} else if (plan.includes("annual")) {
			return "year";
		}
	}
	// builds token
	createToken() {
		var fixed_price = this.state.fixed_price * 100;
		var per_class_price = this.state.per_class_price * 100;
		var fixed_discount = this.state.fixed_discount * 100;

		var tokenBase = {
			code: this.state.code,
			end_date: this.state.end_date,
			plan_type: this.state.plan_type,
			fixed_discount: fixed_discount === 0 ? null : fixed_discount,
			fixed_price: fixed_price,
			per_class_price: per_class_price
		}

		this.props.createDiscountTokens([tokenBase]).then((response) => {
			if (!response.errors) {
				window.wrNotifications.triggerDropDownNotification({
					title: "Done!", text: 'The discount code was created.', icon: "star"
				});
				this.props.fetchDiscountTokens()
				this.setState(this.getInitialFormState());
			}
		});
	}
	// creates initial state
	getInitialFormState() {
		return {
			code: '',
			end_date: moment().format(DateSpans.FORMAT),
			plan_type: _.first(AccountPlans.PAID_PLANS),
			per_class_price: 0,
			fixed_price: 0,
			fixed_discount: 0
		}
	}
// updates updateEditedInformation in state
	updateEditedInformation(attribute, tokenID, event = null, callback = null) {
		var updatedInformation = _.clone(this.state.editedInformation);
		updatedInformation[tokenID] = updatedInformation[tokenID] || {}
		updatedInformation[tokenID][attribute] = event ? event.target.value.replace('$', '') : null;
		if (PRICE_ATTRIBUTES.includes(attribute)) {
			updatedInformation[tokenID][attribute] = parseInt(updatedInformation[tokenID][attribute] * 100);
		}
		this.setState({ editedInformation: updatedInformation }, () => {
			if (callback) { callback(); }
			if (attribute === PLAN_TYPE) { this.submitAndToggle(attribute, tokenID) }
		});
	}
	// submit if enter key is pressed
	onEditKeyPress(attribute, tokenID, event) {
		if (event.keyCode == 13) {
			this.submitAndToggle(attribute, tokenID);
		}
	}
	// submit if enter key is pressed
	onCreateKeyPress(event) {
		if (event.keyCode == 13) {
			this.createToken();
		}
	}

	submitAndToggle(attribute, tokenID) {
		this.submitEditedInformation(attribute, tokenID);
		this.toggleEdit(attribute, tokenID);
	}
	// updates updatedEditingFields
	toggleEdit(attribute, tokenID) {
		var updatedEditingFields = _.clone(this.state.editingFields);
		updatedEditingFields[tokenID] = updatedEditingFields[tokenID] || {}
		updatedEditingFields[tokenID][attribute] = _.findWhere(this.props.discountTokens, { id: tokenID })[attribute];
		if (PRICE_ATTRIBUTES.includes(attribute)) {
			updatedEditingFields[tokenID][attribute] = parseInt(updatedEditingFields[tokenID][attribute]) * 100;
		}
		this.setState({ editingFields: updatedEditingFields });
	}
	// deletes discount token after confirmation
	deleteDiscountToken(tokenID, e) {
		$wr.nope(e);
		if (confirm("Are you sure you want to delete this?")) {
			this.props.deleteToken(tokenID).then(() => {
				setTimeout(function () {
					window.wrNotifications.triggerDropDownNotification({
						title: "Token Deleted", icon: "ok-sign"
					});
				}.bind(this), 1000);
				
				this.props.clearDiscountTokens();
				this.props.fetchDiscountTokens();
			})
		}
	}

	// edits discount token in db
	submitEditedInformation(attribute, tokenID) {
		var tokenObj = this.state.editedInformation[tokenID];
		if (tokenObj) {
			var updatedValue = tokenObj[attribute];
			if (updatedValue != null) {
				this.setState({ loading: true });
				this.props.updateDiscountToken(tokenID, tokenObj).then(() => {

					setTimeout(function () {
						window.wrNotifications.triggerDropDownNotification({
							title: "Information Edited", icon: "ok-sign"
						});
					}.bind(this), 1000);
					this.setState({ loading: false });
					// clear attribute from state
					var updatedEditingFields = _.clone(this.state.editingFields);
					var updatedEditedInformation = _.clone(this.state.editedInformation);

					delete updatedEditingFields[tokenID][attribute]
					delete updatedEditedInformation[tokenID][attribute]

					this.props.fetchDiscountTokens();

					this.setState({ editingFields: updatedEditingFields, editedInformation: updatedEditedInformation });
				})
			}
		}
	}
	// returns form field for editable attributes or table display
	renderEditableTokenAttributes(discountToken, attribute, inputDataType) {
		var displayedAttribute = discountToken[attribute];

		if (inputDataType === 'date' && displayedAttribute) {
			displayedAttribute = moment(displayedAttribute).format('M/DD/YY')
		}
		if (PRICE_ATTRIBUTES.includes(attribute)) {
			displayedAttribute = $wr.centsToDollars(displayedAttribute)
		}
		if (this.state.editingFields[discountToken.id] && this.state.editingFields[discountToken.id][attribute] !== undefined) {
			if (PRICE_ATTRIBUTES.includes(attribute)) {
				return (
					<td>
						<span className='dollarPrefix'>$</span><input type={inputDataType} defaultValue={displayedAttribute.replace('$', '')}
							onKeyDown={this.onEditKeyPress.bind(this, attribute, discountToken.id)}
							onChange={this.updateEditedInformation.bind(this, attribute, discountToken.id)}
							className="form-control editableField discountTokenEditableField inputRight" />
					</td>
				);
			}
			if (attribute === PLAN_TYPE) {
				var pricePlanTypeOptions = this.renderPricePlanOptions()

				return (<td>
					<select defaultValue={discountToken.plan_type}
						className="form-control"
						onChange={this.updateEditedInformation.bind(this, attribute, discountToken.id)}>

						{pricePlanTypeOptions}
					</select>
				</td>)
			}
			return (
				<td>
					<input type={inputDataType} defaultValue={displayedAttribute}
						onKeyDown={this.onEditKeyPress.bind(this, attribute, discountToken.id)}
						onChange={this.updateEditedInformation.bind(this, attribute, discountToken.id)}
						className="form-control editableField discountTokenEditableField" />
				</td>
			);
		} else {
			var editIcon = (<Glyphicon icon="pencil" className="editIcon" />);
			return (
				<td className="editable" onClick={this.toggleEdit.bind(this, attribute, discountToken.id)}>
					<span className="clickableElement">{displayedAttribute}</span> {editIcon}
				</td>
			);
		}
	}
	// returns button to delete discount token
	renderDeleteButton(tokenID) {
		return (
			<button className="btn buttonDanger deleteDiscountToken"
				onClick={this.deleteDiscountToken.bind(this, tokenID)}>
				Delete
			</button>
		)
	}

	renderExistingTokensTable() {
		// filter out old versions of updated discount tokens
		var tokens = _.uniq(_.sortBy(this.props.discountTokens, "id").reverse(), (token) => { return token.id; });
		// produce rows from discount tokens in state
		var tokenRows = _.map(tokens, (discountToken) => {
			var plan = discountToken.plan_type;
			// build url
			if (plan) {
				var planString = "plan=" + this.fetchPlanType(plan) + "&";
				var codeString = "discount_code=" + discountToken.code;
				var periodString = "&period=" + this.fetchPeriod(plan);
				var baseURL = WhooosReadingServices.WebApp.url("/upgrade?");
				var upgradeLink = baseURL + planString + codeString + periodString;
				return (
					<tr key={discountToken.code}>
						{this.renderEditableTokenAttributes(discountToken, CODE, 'text')}
						{this.renderEditableTokenAttributes(discountToken, END_DATE, 'date')}
						{this.renderEditableTokenAttributes(discountToken, PLAN_TYPE, 'select')}
						{this.renderEditableTokenAttributes(discountToken, FIXED_DISCOUNT, 'number')}
						{this.renderEditableTokenAttributes(discountToken, FIXED_PRICE, 'number')}
						{this.renderEditableTokenAttributes(discountToken, PER_CLASS_PRICE, 'number')}
						<td>{discountToken.premium_account_count}</td>
						<td className='linkColumn'><a href={upgradeLink} target="_blank">{upgradeLink}</a></td>
						<td>{this.renderDeleteButton(discountToken.id)}</td>
					</tr>
				);
			}
		})

		return (
			<table className="table table-bordered tokenTable">
				<tbody>
					<tr>
						<th>Code</th>
						<th>End Date</th>
						<th>Plan type</th>
						<th>Fixed Discount</th>
						<th>Fixed Price</th>
						<th>Per Class Price</th>
						<th>Total Accounts</th>
						<th className='linkColumn'>Link</th>
						<th>Delete</th>
					</tr>
					{ tokenRows }
				</tbody>
			</table>
		);
	}
	// retuns array of select options for plan type
	renderPricePlanOptions() {
		return _.map(AccountPlans.PAID_PLANS, (plan_type) => {
			return (<option value={plan_type} key={plan_type}>
				{plan_type}
			</option>)
		})
	}

	renderNewTokensForm() {
		var pricePlanTypeOptions = this.renderPricePlanOptions()

		return (
			<div className="newTokens">
				<p>
					Add new tokens:
				</p>
				<table className="table table-bordered tokenTable">
					<tbody>
						<tr>
							<th>Code</th>
							<th>End Date</th>
							<th>Plan type</th>
							<th>Fixed Discount</th>
							<th>Fixed Price</th>
							<th>Per Class Price</th>
						</tr>
						<tr>
							<td>
								<input type='text' className="form-control" defaultValue={this.state.code}
									onKeyDown={this.onCreateKeyPress}
									onChange={(e) => this.setState({ code: e.target.value })} />
							</td>
							<td>
								<DatePicker className="form-control"
									selected={moment(this.state.end_date)}
									onChange={(date) => this.setState({ end_date: date.format(DateSpans.FORMAT) })} />
							</td>
							<td className='planTypeColumn'>
								<select defaultValue={this.state.plan_type}
									className="form-control"
									onChange={(e) => this.setState({ plan_type: e.target.value })}>

									{pricePlanTypeOptions}
								</select>
							</td>
							<td className='currencyColumn'>
								<span className="currencyinput">$</span>
								<input type='number' className="form-control inputRight" defaultValue={$wr.centsToDollars(this.state.fixed_discount)}
									onKeyDown={this.onCreateKeyPress}
									onChange={(e) => this.setState({ fixed_discount: e.target.value })} />
							</td>
							<td className='currencyColumn'>
								<span className="currencyinput">$</span>
								<input type='number' className="form-control inputRight" defaultValue={$wr.centsToDollars(this.state.fixed_price)}
									onKeyDown={this.onCreateKeyPress}
									onChange={(e) => this.setState({ fixed_price: e.target.value })} />
							</td>
							<td className='currencyColumn'>
								<span className="currencyinput">$</span>
								<input type='number' className="form-control inputRight" defaultValue={$wr.centsToDollars(this.state.per_class_price)}
									onKeyDown={this.onCreateKeyPress}
									onChange={(e) => this.setState({ per_class_price: e.target.value })} />
							</td>
						</tr>
					</tbody>
				</table>
				<div className="text-center">
					<button className="btn buttonSuccess" onClick={this.createToken}>
						Create Token
					</button>
				</div>
			</div>
		);
		
	}
	render() {
		if (this.props.loadingDiscountTokens) {
			var tokenTable = (
				<div>
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		} else {
			var innerTokens = this.renderExistingTokensTable();
		}
		return (
			<div className="discountTokenPage">
				<div className="headerSection">
					<header className="pageHeader">
						<h1>Discount Codes</h1>
					</header>
					{ this.renderNewTokensForm() }
					{ innerTokens }
				</div>
			</div>
		);
	}

	componentDidMount() {
		this.props.fetchDiscountTokens()
	}

};

var CODE = 'code';
var END_DATE = 'end_date';
var PLAN_TYPE = 'plan_type';
var FIXED_DISCOUNT = 'fixed_discount';
var FIXED_PRICE = 'fixed_price';
var PER_CLASS_PRICE = 'per_class_price';
var PRICE_ATTRIBUTES = [FIXED_DISCOUNT, FIXED_PRICE, PER_CLASS_PRICE]

DiscountTokenPage.WrappedComponent.propTypes = PageStrictPropTypes({
	// Data from @connect
	discountTokens: PropTypes.array.isRequired,

	// Handlers from @connect
	fetchDiscountTokens: PropTypes.func.isRequired,
	createDiscountTokens: PropTypes.func.isRequired,
	updateDiscountToken: PropTypes.func.isRequired,
	deleteToken: PropTypes.func.isRequired,
	clearDiscountTokens: PropTypes.func.isRequired
});

module.exports = DiscountTokenPage;



// WEBPACK FOOTER //
// ./modules/components/appdev/crm/DiscountTokenPage.js